import { LocalTime } from 'js-joda';
import clsx from 'clsx';

import { DisplayTime } from '@tock/time';
import { IWithContextProps, withContext } from '@tock/coretypes';
import { IconChevronDown } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { TimeValueOption } from 'types';
import { Typography } from 'omakase';
import { css } from '@emotion/react';
import BaseComponent from '@tock/shared/components/BaseComponent';
import Input from '@tock/shared/components/inputs/Input';
import InputContainer from '@tock/shared/components/forms/InputContainer';

interface Props {
  displayedTimes: TimeValueOption[];
  onSelectTime(time: string): void;
  rotateArrow?: boolean;
  selectedTime: LocalTime;
  timeClassName: string;
  locale?: string;
}

interface State {
  showTimeSelector: boolean;
  isActive: boolean;
}

class SearchBarTimeSection extends BaseComponent<Props & IWithContextProps, State> {
  constructor(props: Props & IWithContextProps) {
    super(props);
    this.state = {
      showTimeSelector: false,
      isActive: false,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleSelectTime(event: any) {
    const viewValue = event.target.value;
    this.props.onSelectTime(viewValue);
  }

  handleFocus() {
    this.setState({
      isActive: true,
    });
  }

  handleBlur() {
    this.setState({
      isActive: false,
    });
  }

  render() {
    const {
      displayedTimes,
      rotateArrow,
      selectedTime,
      timeClassName,
      locale,
      context: { isFeatureEnabled },
    } = this.props;
    const { showTimeSelector } = this.state;
    const arrowClassName = clsx(`SearchBarSectionSelectionIcon tock-icon icon_small-arrow-down`, {
      'is-open': showTimeSelector && rotateArrow,
    });

    const searchBarClassName = clsx('Dropdown-section', {
      'is-active': this.state.isActive,
    });
    const fakeField = {
      onBlur: this.handleBlur,
      onChange: this.handleSelectTime,
      value: selectedTime,
    };

    const isSakeIconSetEnabled = isFeatureEnabled('SAKE_ICON_SET');

    return (
      <InputContainer
        className={clsx(timeClassName, searchBarClassName)}
        data-testid="reservation-search-time-container"
      >
        <Input
          {...this.props}
          classNames={clsx('Select-input', 'Dropdown-section--select')}
          data-testid="reservation-search-time"
          options={displayedTimes}
          type="select"
          placeholder="Desired reservation time"
          value={selectedTime.toString()}
          field={fakeField}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />

        <div
          className="SearchBar-sectionDropdown"
          css={[
            isSakeIconSetEnabled &&
              css`
                // TODO: add to SCSS styles for consistency after FF is launched
                padding-right: 1.2rem;
              `,
          ]}
        >
          <div className="SearchBar-sectionDropdownContent">
            <div
              css={css`
                align-items: flex-start;
                display: flex;
                flex-direction: column;
              `}
            >
              <Typography variant="caption" color="fgSubtle">
                Time
              </Typography>
              <Typography variant="body02" color="fgDefault" data-testid="Select-text">
                <DisplayTime timeValue={selectedTime} localeFromProps={locale} />
              </Typography>
            </div>
          </div>
          <IconMigrationUtil
            legacyIcon={<div className={arrowClassName} />}
            newIcon={<IconChevronDown />}
          />
        </div>
      </InputContainer>
    );
  }
}

export default withContext(SearchBarTimeSection);
